<div class="default-dialog">
    <div class="dialog-header">
        <h3>{{ 'INFO_POP_UP.TITLE' | translate }}</h3>
        <div class="header-close">
            <button mat-icon-button color="primary" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content [innerHTML]="'INFO_POP_UP.CONTENT' | translate"> </mat-dialog-content>
    <mat-dialog-actions>
        <a
            mat-stroked-button
            [href]="'INFO_POP_UP.LINK' | translate"
            target="_blank"
            *ngIf="checkTranslationKeyExists('INFO_POP_UP.LINK')"
            >{{ 'COMMON.MORE' | translate }}</a
        >
        <button mat-raised-button color="primary" [mat-dialog-close]="true">
            {{ 'INFO_POP_UP.NEXT' | translate }}
        </button>
    </mat-dialog-actions>
</div>
